// subtitle-title-image-more.js
// Ensures .bg and .fg images are only shown after both are loaded

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.subtitle-title-image-more').forEach(function(container) {
    var bg = container.querySelector('.bg');
    var fg = container.querySelector('.fg');
    if (!bg || !fg) return;
    container.classList.add('images-loading');
    bg.style.opacity = '0';
    fg.style.opacity = '0';
    bg.style.visibility = 'hidden';
    fg.style.visibility = 'hidden';
    bg.style.transition = 'opacity 0.4s';
    fg.style.transition = 'opacity 0.4s';
    var bgLoaded = false, fgLoaded = false;
    function showBoth() {
      if (bgLoaded && fgLoaded) {
        bg.style.visibility = '';
        fg.style.visibility = '';
        bg.style.opacity = '1';
        fg.style.opacity = '1';
        container.classList.remove('images-loading');
      }
    }
    function onBgLoad() { bgLoaded = true; showBoth(); }
    function onFgLoad() { fgLoaded = true; showBoth(); }
    bg.addEventListener('load', onBgLoad);
    fg.addEventListener('load', onFgLoad);
    // In case images are cached
    if (bg.complete) { bgLoaded = true; }
    if (fg.complete) { fgLoaded = true; }
    // Only show if both are loaded (including cached)
    if (bgLoaded && fgLoaded) {
      showBoth();
    }
  });
});
